export type BlogPostSummary = {
  slug: string;
  headline: string;
  published: string;
  datePublished: string;
  dateModified: string;
  title: string;
  description: string;
  heroImage: string;
  heroAlt: string;
  ogTitle: string;
  ogDescription: string;
  ogUrl: string;
  ogImage: string;
  twitterTitle: string;
  twitterDescription: string;
  twitterImage: string;
};

export const blogPostSummaries: BlogPostSummary[] = [
  {
    slug: "owners-vs-lenders-title-insurance-florida",
    headline: "Owner's vs. Lender's Title Insurance in Florida: What Each Policy Covers",
    published: "October 1, 2026 · Premier Title Solutions",
    datePublished: "2026-10-01T09:00:00-04:00",
    dateModified: "2026-10-01T09:00:00-04:00",
    title: "Florida Owner & Lender Title Coverage | Premier Title",
    description: "Learn how owner's and lender's title insurance protect different interests in a Florida home purchase, what each policy covers, and who usually pays.",
    heroImage: "/manus-storage/owners-lenders-title-insurance_7cb91b5b.webp",
    heroAlt: "House keys and closing documents in a sunlit South Florida home setting",
    ogTitle: "Florida Owner & Lender Title Coverage | Premier Title",
    ogDescription: "Learn how owner's and lender's title insurance protect different interests in a Florida home purchase, what each policy covers, and who usually pays.",
    ogUrl: "https://mypremiertitle.com/blog/owners-vs-lenders-title-insurance-florida",
    ogImage: "https://mypremiertitle.com/manus-storage/owners-lenders-title-insurance_7cb91b5b.webp",
    twitterTitle: "Florida Owner & Lender Title Coverage | Premier Title",
    twitterDescription: "Learn how owner's and lender's title insurance protect different interests in a Florida home purchase, what each policy covers, and who usually pays.",
    twitterImage: "https://mypremiertitle.com/manus-storage/owners-lenders-title-insurance_7cb91b5b.webp",
  },
  {
    slug: "real-estate-wire-fraud-prevention",
    headline: "Real Estate Wire Fraud: How to Protect Your Closing Funds",
    published: "October 8, 2026 · Premier Title Solutions",
    datePublished: "2026-10-08T09:00:00-04:00",
    dateModified: "2026-10-08T09:00:00-04:00",
    title: "Real Estate Wire Fraud: How to Protect Your Closing Funds",
    description: "Real estate wire fraud targets buyers and sellers with fake wiring instructions. Learn the red flags, how to verify instructions, and what to do fast.",
    heroImage: "/manus-storage/real-estate-wire-fraud-prevention-property-verification_4181b0fc.webp",
    heroAlt: "Verified entry intercom overlooking South Florida waterfront residences",
    ogTitle: "Real Estate Wire Fraud: How to Protect Your Closing Funds",
    ogDescription: "Real estate wire fraud targets buyers and sellers with fake wiring instructions. Learn the red flags, how to verify instructions, and what to do fast.",
    ogUrl: "https://mypremiertitle.com/blog/real-estate-wire-fraud-prevention",
    ogImage: "https://mypremiertitle.com/manus-storage/real-estate-wire-fraud-prevention-property-verification_4181b0fc.webp",
    twitterTitle: "Real Estate Wire Fraud: How to Protect Your Closing Funds",
    twitterDescription: "Real estate wire fraud targets buyers and sellers with fake wiring instructions. Learn the red flags, how to verify instructions, and what to do fast.",
    twitterImage: "https://mypremiertitle.com/manus-storage/real-estate-wire-fraud-prevention-property-verification_4181b0fc.webp",
  },
  {
    slug: "firpta-withholding-florida-property-sale",
    headline: "FIRPTA Withholding When Selling Florida Property: A Guide for Foreign Sellers",
    published: "October 15, 2026 · Premier Title Solutions",
    datePublished: "2026-10-15T09:00:00-04:00",
    dateModified: "2026-10-15T09:00:00-04:00",
    title: "FIRPTA Withholding for Florida Sellers | Premier Title",
    description: "Learn how FIRPTA withholding works when a foreign seller sells Florida property, including the 15%, 10%, and 0% rates and exceptions to plan for.",
    heroImage: "/manus-storage/firpta-withholding-florida-property-sale-coastal-condos_15a934a2.webp",
    heroAlt: "South Florida waterfront condominiums and palm trees on a bright day",
    ogTitle: "FIRPTA Withholding for Florida Sellers | Premier Title",
    ogDescription: "Learn how FIRPTA withholding works when a foreign seller sells Florida property, including the 15%, 10%, and 0% rates and exceptions to plan for.",
    ogUrl: "https://mypremiertitle.com/blog/firpta-withholding-florida-property-sale",
    ogImage: "https://mypremiertitle.com/manus-storage/firpta-withholding-florida-property-sale-coastal-condos_15a934a2.webp",
    twitterTitle: "FIRPTA Withholding for Florida Sellers | Premier Title",
    twitterDescription: "Learn how FIRPTA withholding works when a foreign seller sells Florida property, including the 15%, 10%, and 0% rates and exceptions to plan for.",
    twitterImage: "https://mypremiertitle.com/manus-storage/firpta-withholding-florida-property-sale-coastal-condos_15a934a2.webp",
  },
];
